// extracted by mini-css-extract-plugin
export default {"Container":"insights-layout-module__Container--nv5VZ","Pane":"insights-layout-module__Pane--C0Veo","MainContent":"insights-layout-module__MainContent--Q5PG9"};